import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个套餐类型。
 * @enum
 * @version 1.0.0
 */
enum reserveType
{
    /**
     * 体检。
     * @member
     */
    physical = 1,

    /**
     * 口腔
     * @member
     */
    oralCavity = 2,

    /**
     * 绿色就医 
     * @member
     */
    greenMedical = 3,

    /**
     * 眼科
     * @member
     */
    ophthalmology = 4,

    /**
     * 陪诊
     * @member
     */
    escort = 5,

    /**
     * 基因
     * @member
     */
    gene = 6
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(reserveType,
{
    physical:
    {
        alias: "体检",
        description: ""
    },
    oralCavity:
    {
        alias: "口腔",
        description: ""
    },
    greenMedical:
    {
        alias: "绿色就医",
        description: ""
    },
    ophthalmology:
    {
        alias: "眼科",
        description: ""
    },
    escort:
    {
        alias: "陪诊",
        description: ""
    },
    gene:
    {
        alias: "基因",
        description: ""
    }
});

export default reserveType;
